var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143,
    height: 56,
    viewBox: "0 0 34.846 18.711",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#020202;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.795)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.795)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M14.83,18.711l1.055-4.344L10.3,14.118l9.092-7.757-1.614-.248L19.423,0h5.12L28.08,4.22,34.379,0h6.268l-.776,3.786,5.275.186-9.309,8.037,1.551.279-1.334,6.423h-6.02l1.427-6.578-5.554,4.034-3.32-4.034-1.582,6.578Z",
    transform: "translate(-10.3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionLogo);
export default __webpack_public_path__ + "static/media/motion-logo.797c0eeaa9439e91ff048f14597d955f.svg";
export { ForwardRef as ReactComponent };